import { render } from "./MenuRight.vue?vue&type=template&id=7666acb4"
import script from "./MenuRight.vue?vue&type=script&lang=js"
export * from "./MenuRight.vue?vue&type=script&lang=js"

import "./MenuRight.vue?vue&type=style&index=0&id=7666acb4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__